export const MARITAL_LOADING = "MARITAL_LOADING";
export const MARITAL_RESET = "MARITAL_RESET";
export const GET_MARITAL = "GET_MARITAL";
export const GET_MARITAL_SUCCESS = "GET_MARITAL_SUCCESS";
export const GET_MARITAL_FAIL = "GET_MARITAL_FAIL";
export const DELETE_MARITAL = "DELETE_MARITAL";
export const DELETE_MARITAL_SUCCESS = "DELETE_MARITAL_SUCCESS";
export const DELETE_MARITAL_FAIL = "DELETE_MARITAL_FAIL";
export const UPDATE_MARITAL = "UPDATE_MARITAL";
export const UPDATE_MARITAL_SUCCESS = "UPDATE_MARITAL_SUCCESS";
export const UPDATE_MARITAL_FAIL = "UPDATE_MARITAL_FAIL";
export const ADD_NEW_MARITAL = "ADD_NEW_MARITAL";
export const ADD_MARITAL_SUCCESS = "ADD_MARITAL_SUCCESS";
export const ADD_MARITAL_FAIL = "ADD_MARITAL_FAIL";
